// extracted by mini-css-extract-plugin
export default {"textOverflow":"lqoqXFMFHM0WCkTxZ0r6","textOverflowContent":"Zl3rRqFKR8EmH0dQq4SO"};